import { connect } from 'react-redux'
import _ from 'lodash'
import { isArray } from 'core/service/lib/type-check'
import { Tab as NavTab } from 'common-components'
import { NavigationItem } from 'quick-quote/components'
import { getNavTabList } from './navigations/tabs'
import store from 'e-submission/store'
import { useHistory } from 'react-router-dom'

export const _NavigationMenu = (navProps) => {
  const tabList = isArray(navProps.pages) ? navProps.pages : navProps.navTabList
  const currentPath = navProps.location.pathname
  if (/e-submission\/form\/.+/g.test(currentPath)) {
    const directingState = store.getState()
    const currentAppId = _.get(directingState, 'apps.currentAppId')
    if (!currentAppId) {
      try {
        const history = useHistory()
        history.push('/')
        return null
      } catch (e) {
        console.error(`ERROR _NavigationMenu backToHome :`, e.message)
      }
    }
  }

  if (tabList.length === 0) return null
  else {
    return (
      <NavTab active={currentPath} className="header-nav">
        {tabList
          .filter((tab) => !tab.hide)
          .map((tab) => (
            <NavTab.Item id={tab.path} key={tab.id} disabled={tab.disabled}>
              <NavigationItem tab={tab} />
            </NavTab.Item>
          ))}
      </NavTab>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  navTabList: getNavTabList({ state, location: ownProps.location }),
  state: state
})

export const Nav = connect(mapStateToProps)(_NavigationMenu)
